import {Button, Grid, Toolbar, Typography} from '@mui/material';
import {styled, Theme, CSSObject} from '@mui/material/styles';
import {APP} from 'src/styles/variables';

export const openedMixin = (theme: Theme): CSSObject => ({
  width: 240,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden'
});

export const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`
  }
});

export const DrawerHeader = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar
}));

export const ToolBarStyle = styled(Toolbar)`
  height: inherit;
  padding: 0 0 0 16px !important;
`;

export const InfoGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 10px;
  padding-right: 16px;
  height: 100%;
`;

export const PersonalInfoGrid = styled(Grid)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  font-size: 8px;
  padding-right: 70px;
  padding-top: 15px;
  flex-wrap: nowrap;
`;

export const EncounterContainerDiv = styled('div')`
  padding: 5px 10px;
  font-size: 0.45rem;
  height: 40px;
  background: #00000010;
  border-radius: 8px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const PAEncounterContainerDiv = styled('div')`
  padding: 5px 10px;
  font-size: 0.45rem;
  height: 40px;
  background:#ff5630d1;
  border-radius: 8px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const EncounterDiv = styled('div')`
  font-size: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FilterDataDiv = styled('div')`
  font-weight: 700;
  color: ${APP.PALETTE.SUB_MODULE_COLOR.RED};
  font-size: 1.2rem;
  margin-left: 5px;
`;

export const HeadingTypography = styled(Typography)`
  font-weight: 600;
  font-size: 15px;
`;

export const ContentTypography = styled(Typography)`
  font-weight: 500;
  font-size: 15px;
`;

export const HeaderImageGrid = styled(Grid)`
  display: flex;
  width: 500px;
  height: 40px;
  opacity: 0.9;
  color: ${APP.PALETTE.COMMON.WHITE};
  margin-left: 2rem;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const SignOutButton = styled(Button)`
  color: white;
  fontsize: 0.875rem;
  text-transform: none;
  width: 5rem;
  height: 58px;
  margin: 0;
  box-shadow: none;

  &:hover {
    color: ${APP.PALETTE.COMMON.WHITE};
    background-color: ${APP.PALETTE.SUB_MODULE_COLOR.SECONDARY};
    box-shadow: 1;
  }

  && .MuiTouchRipple-child {
    color: ${APP.PALETTE.COMMON.WHITE};
    background-color: ${APP.PALETTE.SUB_MODULE_COLOR.SECONDARY};
  }
`;

export const PadButton = styled(Button)`
  text-transform: none;
  background-color: ${APP.PALETTE.COMMON.WHITE};
  border-radius: 5rem;
  height: 2rem;

  .MuiButton-startIcon {
    margin-top: 0 !important;
  }
`;
